'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icons"];
import { DropdownIconItem } from "../../primitive-dropdown/dropdown-icon-item";
import { AsyncGenericDropdown } from "./async-generic-dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
export function AsyncIconsDropdown(_ref) {
  var icons = _ref.icons,
    props = _objectWithoutProperties(_ref, _excluded);
  var options = icons.map(function (option) {
    return {
      value: option.value,
      label: option.title,
      element: function element(elementProps) {
        return /*#__PURE__*/_jsx(DropdownIconItem, _objectSpread({
          icon: option
        }, elementProps));
      }
    };
  });
  return /*#__PURE__*/_jsx(AsyncGenericDropdown, _objectSpread(_objectSpread({}, props), {}, {
    options: options
  }));
}